var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsChargers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.47,412a4.61,4.61,0,0,1-.53,0c-60.05-2.18-133.22-43.82-138.43-96.86-4-40.82,20.17-84.87,55.1-100.31,23.2-10.23,43.34-5.2,61.1-.73s29.26,6.82,42.11-.49c15.23-8.63,26.05-27.39,26.33-45.62.35-24.5-18.73-41.35-25-46.88-43.76-38.69-119-10.7-119.79-10.42A14.3,14.3,0,0,1,95.18,83.89c3.75-1.41,92.35-34.25,148.9,15.71,23.37,20.63,35,43.76,34.68,68.77-.43,28.3-16.83,56.46-40.83,70.08-23.47,13.31-44.59,8-63.2,3.34-15.22-3.83-28.32-7.14-42.57-.84-23.89,10.54-41,42.55-38.18,71.32,3.76,38.22,65.94,69.44,111,71.09",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,285.7h83.37A22.34,22.34,0,0,1,413.44,308V481.67A22.33,22.33,0,0,1,391.11,504H308.25a22.33,22.33,0,0,1-15-5.79l-66.51-60.33a22.32,22.32,0,0,1-7.33-16.54v-58a22.34,22.34,0,0,1,8-17.12l66-55.27A22.38,22.38,0,0,1,307.74,285.7Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 311.13,
    width: 79.76,
    height: 57.37,
    rx: 0.42,
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.16,
    y: 419.57,
    width: 79.76,
    height: 57.37,
    rx: 0.42,
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsChargers);
export default __webpack_public_path__ + "static/media/CMS_Chargers.d235d9f5dbbb1778920dd13212cf3ea9.svg";
export { ForwardRef as ReactComponent };